import React, { createContext, useContext } from "react";
import { Layout, Menu } from "antd";
import { observer } from "mobx-react-lite";
import SettingStore from "../settings/store/settingstore";
import { WRFMBase } from "./wrfm/WRFMBase";
import { DailyProductionTabs } from "./daily-templates/DailyProductionTabs";
import { CommercialObligationsBaseView } from "./commercial/CommercialObligationsBaseView";
import { MonthlySettingsBaseView } from "./monthly-templates/MonthlySettingsBaseView";
import { ProductionLock } from "./production-data-lock/ProductionLock";
const { Content, Sider } = Layout;

const settingStorectx = createContext(SettingStore);

export const SettingsBaseView = observer(() => {
  const settingStore = useContext(settingStorectx);
  const renderChildren = () => {
    const selectKey = settingStore.selectedKey;
    switch (selectKey) {
      case "1":
        return <DailyProductionTabs />;

      case "2":
        return <MonthlySettingsBaseView />;
      case "3":
        return <CommercialObligationsBaseView />;
      case "4":
        return <WRFMBase />;
      case "5":
        return <ProductionLock />;
      default:
        break;
    }

    return null;
  };
  return (
    <Layout style={{ background: "#fff", padding: "10px" }}>
      <Content>
        <Layout>
          <Sider width={200} style={{ background: "#fff" }}>
            <Menu
              mode="inline"
              defaultSelectedKeys={[settingStore.selectedKey]}
              defaultOpenKeys={["sub1"]}
              style={{ height: "100%", width: "224px" }}
              onClick={async ({ key }) => {
                settingStore.selectedKey = key;
              }}
            >
              <Menu.Item key="1">
                <span>Input Deck</span>{" "}
              </Menu.Item>
              <Menu.Item key="2">
                <span>Hierarchy Management</span>
              </Menu.Item>
              <Menu.Item key="3">
                {" "}
                <span>Commercial</span>
              </Menu.Item>
              <Menu.Item key="4">
                <span>WRFM</span>
              </Menu.Item>
              <Menu.Item key="5">
                <span>Production Data Lock</span>
              </Menu.Item>
            </Menu>
          </Sider>
          <Content>
            {" "}
            <div className="ms-Grid" dir="ltr">
              <div
                className="ms-Grid-row"
                style={{ paddingLeft: "24px", backgroundColor: "white" }}
              >
                <div className="ms-Grid-col ms-sm12">{renderChildren()}</div>
              </div>
            </div>
          </Content>
        </Layout>
      </Content>
    </Layout>
  );
});

